import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { install } from '@twind/core';
import config from './twind.config';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import CTA from './components/CTA';
import Footer from './components/Footer';
// Install Twind with React integration
install(config);
// Apply body styling that was previously in styles.css
document.body.classList.add('bg-gradient-to-br', 'from-slate-50', 'to-blue-50', 'dark:from-slate-900', 'dark:to-blue-950', 'min-h-screen');
var App = function () {
    return (_jsxs("div", { className: "min-h-screen flex flex-col", children: [_jsx(Header, {}), _jsxs("main", { className: "flex-grow", children: [_jsx(Hero, {}), _jsx(Features, {}), _jsx(HowItWorks, {}), _jsx(CTA, {})] }), _jsx(Footer, {})] }));
};
export default App;
